// src/hooks/useEntitlements.ts
//
// Single access point for per-tenant feature availability. Reads the
// backend-reported entitlements from auth state and resolves them against the
// build-time feature flags. Components gate feature UI on this rather than on a
// global build flag.

import { useMemo } from "react";

import { useAuth } from "../contexts/AuthContext";
import { resolveEntitlements, type EffectiveEntitlements } from "../config/featureEntitlements";

export function useEntitlements(): EffectiveEntitlements {
  const { featureEntitlements } = useAuth();
  return useMemo(() => resolveEntitlements(featureEntitlements), [featureEntitlements]);
}
